import { useTranslation } from "react-i18next";

export type AccountingReferenceGroupId =
  | "accounts_payable"
  | "accounts_receivable"
  | "gratuity"
  | "variance"
  | "processing_fees"
  | "network_cost_fees"
  | "deposit"
  | "service_fees"
  | "overpayment_refund"
  | "loyalty_redemption"
  | "none";

type AccountingReferenceGroup = {
  id: AccountingReferenceGroupId;
  label: string;
};

/**
 * Translated Accounting Reference Dropdown Information.
 * Keep in sync with Tee-On-API App\Enums\AccountingReferenceGroup.
 */
export const useAccountingReferenceGroups = (): AccountingReferenceGroup[] => {
  const { t } = useTranslation();

  return [
    { id: "accounts_payable", label: t("Accounts Payable") },
    { id: "accounts_receivable", label: t("Accounts Receivable") },
    { id: "gratuity", label: t("Gratuities") },
    { id: "variance", label: t("Variance") },
    { id: "processing_fees", label: t("Processing Fees") },
    { id: "network_cost_fees", label: t("Network Costs") },
    { id: "deposit", label: t("Deposit") },
    { id: "service_fees", label: t("Service Fees") },
    { id: "overpayment_refund", label: t("Customer Overpayments") },
    { id: "loyalty_redemption", label: t("Loyalty Redemptions") },
    { id: "none", label: t("None") },
  ];
};
